import script from "./School.vue?vue&type=script&setup=true&lang=js"
export * from "./School.vue?vue&type=script&setup=true&lang=js"

import "./School.vue?vue&type=style&index=0&id=5ff2e945&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff2e945"]])

export default __exports__